// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"8f442e04","52":"2f2bd51e","271":"a2e42663","363":"ceceed4a","378":"a63e5818","640":"6d8de057","671":"27c03103","681":"630e2d3a","776":"c904ce73","798":"f06ba7ff","912":"339ec9b6"}[chunkId] + ".chunk.js";
};